/**
 * scroll-reveal.js
 * Vanilla-JS scroll reveal + count-up utility for Dawn-based Shopify themes.
 * Load with `defer` in theme.liquid:
 *   <script src="{{ 'scroll-reveal.js' | asset_url }}" defer></script>
 *
 * Markup:
 *   <div data-scroll-reveal data-scroll-animation="fade-up" data-scroll-delay="100">...</div>
 *   <span data-count-to="10" data-count-suffix="+">0</span>
 *
 * Animation variants (data-scroll-animation): fade-up (default), fade-in, scale-in
 */
(function () {
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealImmediately(elements) {
    elements.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function initScrollReveal() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('[data-scroll-reveal]'));
    if (!elements.length) return;

    if (prefersReducedMotion) {
      revealImmediately(elements);
      return;
    }

    elements.forEach(function (el) {
      var delay = el.getAttribute('data-scroll-delay');
      if (delay) el.style.transitionDelay = delay + 'ms';
    });

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  function easeOutQuad(t) {
    return 1 - (1 - t) * (1 - t);
  }

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count-to'));
    if (isNaN(target)) return;

    var suffix = el.getAttribute('data-count-suffix') || '';
    var prefix = el.getAttribute('data-count-prefix') || '';
    var decimals = el.getAttribute('data-count-decimals');
    decimals = decimals ? parseInt(decimals, 10) : 0;
    var duration = 1200;
    var start = null;

    if (prefersReducedMotion) {
      el.textContent = prefix + target.toFixed(decimals) + suffix;
      return;
    }

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = easeOutQuad(progress);
      var current = target * eased;
      el.textContent = prefix + current.toFixed(decimals) + suffix;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = prefix + target.toFixed(decimals) + suffix;
      }
    }
    window.requestAnimationFrame(step);
  }

  function initCountUp() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('[data-count-to]'));
    if (!elements.length) return;

    if (prefersReducedMotion) {
      elements.forEach(animateCount);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    initScrollReveal();
    initCountUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();